module.exports = __webpack_public_path__ + "static/img/backg1.febab87f.png";